<!-- Rename Folder Modal -->
<div class="modal-content">
  <div class="modal-body">
    <div class="fc_modal_body">
      <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="this.activeModal.close()"></button>
      <h3 class="h3">{{file?"File name":"Rename folder"}}</h3>
      <form method="get" class="fc_form" #fileForm="ngForm" id="fileForm">
        <div class="form-group mb-3">
          <label for="folder" class="form-label">{{file?"Enter the File name":"Folder name"}}</label>
          <input [(ngModel)]="name" type="text" maxlength="25" name="filename" #filename="ngModel" class="form-control" required>
        </div>
        @if (filename && filename.invalid && filename.touched) {
          <div class="help-block" style="color:red">FileName is
          required!</div>
        }
        <div class="form-group d-flex justify-content-between align-items-center mb-0">
          <button type="button" class="border_btn" data-bs-dismiss="modal"
          (click)="this.activeModal.close()">Cancel</button>
          <button type="submit" class="primary_btn" (click)="close(name)">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>